export default function lingeringTooltip($document) {
  'ngInject';

  return {
    restrict: 'AE',
    replace: true,
    scope: true,
    transclude: true,
    template: `
      <div uib-tooltip-template="template"
           tooltip-append-to-body="true"
           tooltip-trigger="'none'"
           tooltip-placement="{{ ::tooltipPlacement }}"
           tooltip-is-open="isTooltipOpen"
           tooltip-class="{{ tooltipClass }}"
           ng-mouseenter="$show()">
        <span ng-transclude></span>
      </div>
    `,
    controller($scope, $timeout, $attrs) {
      'ngInject';

      let timer;

      Object.defineProperty($scope, 'template', {
        get() {
          return $scope.$eval($attrs.template);
        },
      });

      $attrs.$observe('tooltipCustomClass', (v) => {
        $scope.tooltipClass = v;
      });

      $scope.tooltipPlacement = $attrs.placement;

      $scope.$on('lingering-tooltip:show', (event, id) => {
        if (id === $attrs.tooltipId) {
          $scope.$show();
        }
      });

      $scope.$show = function $show() {
        $timeout.cancel(timer);
        $scope.isTooltipOpen = true;
      };

      $scope.$hide = function $hide(timeout) {
        $timeout.cancel(timer);
        timer = $timeout(() => {
          $scope.isTooltipOpen = false;
        }, timeout ?? 300);
      };
    },
    link($scope, $element, $attrs) {
      function onDocumentClick() {
        $scope.$evalAsync('$hide(0)');
        $document.off('click', onDocumentClick);
      }

      if ($attrs.keepUntilClick) {
        $document.on('click', onDocumentClick);
        $scope.$on('$destroy', () => {
          $document.off('click', onDocumentClick);
        });
      } else {
        $element.on('mouseleave', () => {
          $scope.$evalAsync('$hide()');
        });
      }
    },
  };
}
